import script from "./PostManagement.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostManagement.vue?vue&type=script&setup=true&lang=ts"

import "./PostManagement.vue?vue&type=style&index=0&id=0df58204&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0df58204"]])

export default __exports__